export default{
  get (key, msg = {}) {
    for (let i in msg) {
      this.box[i] = msg[i]
    }
    return this.box[key] || key
  },
  box: {
    Success: '请求成功',
    RequestError: '请求方式错误',
    NonExistentError: '请求数据不存在'
  }
}



// WEBPACK FOOTER //
// ./src/common/msgbox.js